var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.contests.config
    ? _c(
        "div",
        { attrs: { id: "top" } },
        [
          _vm.loadingState ? _c("loading") : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row mt-5 pt-5" }, [
              _vm.contests.config
                ? _c("div", { staticClass: "col-12 center" }, [
                    _c("img", {
                      staticClass: "img img-fluid",
                      attrs: { src: _vm.contests.config.LOGO_INTERNO }
                    })
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("nav", {}, [
              _c(
                "div",
                {
                  staticClass: "nav nav-tabs mt-3",
                  attrs: { id: "nav-tab", role: "tablist" }
                },
                [
                  _vm.contest
                    ? _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link active",
                          style:
                            "background-color:" +
                            _vm.contests.config.COLORE_PRINCIPALE,
                          attrs: {
                            id: "nav-home-tab",
                            "data-toggle": "tab",
                            href: "#nav-home",
                            role: "tab",
                            "aria-controls": "nav-home",
                            "aria-selected": "true"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(1)
                            }
                          }
                        },
                        [_vm._v("Promozione")]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link active",
                          attrs: {
                            id: "nav-home-tab",
                            "data-toggle": "tab",
                            href: "#nav-home",
                            role: "tab",
                            "aria-controls": "nav-home",
                            "aria-selected": "true"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(1)
                            }
                          }
                        },
                        [_vm._v("Promozione")]
                      ),
                  _vm._v(" "),
                  _vm.info
                    ? _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          style:
                            "background-color:" +
                            _vm.contests.config.COLORE_PRINCIPALE,
                          attrs: {
                            id: "nav-profile-tab",
                            "data-toggle": "tab",
                            href: "#nav-profile",
                            role: "tab",
                            "aria-controls": "nav-profile",
                            "aria-selected": "false"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(2)
                            }
                          }
                        },
                        [_vm._v("dettaglio caricamenti")]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          attrs: {
                            id: "nav-profile-tab",
                            "data-toggle": "tab",
                            href: "#nav-profile",
                            role: "tab",
                            "aria-controls": "nav-profile",
                            "aria-selected": "false"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(2)
                            }
                          }
                        },
                        [_vm._v("dettaglio caricamenti")]
                      ),
                  _vm._v(" "),
                  _vm.premi
                    ? _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          style:
                            "background-color:" +
                            _vm.contests.config.COLORE_PRINCIPALE,
                          attrs: {
                            id: "nav-profile-tab",
                            "data-toggle": "tab",
                            href: "#nav-profile",
                            role: "tab",
                            "aria-controls": "nav-profile",
                            "aria-selected": "false"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(3)
                            }
                          }
                        },
                        [_vm._v("catalogo premi")]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          attrs: {
                            id: "nav-profile-tab",
                            "data-toggle": "tab",
                            href: "#nav-profile",
                            role: "tab",
                            "aria-controls": "nav-profile",
                            "aria-selected": "false"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeView(3)
                            }
                          }
                        },
                        [_vm._v("catalogo premi")]
                      )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          !_vm.info && _vm.contest && !_vm.premi
            ? _c(
                "div",
                {
                  staticClass: "container padd pt-2 pb-5",
                  attrs: { id: "nav-home" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row justify-content-center pb-5 pt-3 back-white"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-md-9 mt-3 center",
                          class: { "back-color-3": _vm.empty },
                          on: {
                            click: function($event) {
                              return _vm.toContest()
                            }
                          }
                        },
                        [
                          _vm.my_registration_in_promo <= _vm.maxRegistration &&
                          _vm.moment(_vm.now) <=
                            _vm.moment(_vm.end_, "YYYY-MM-DD")
                            ? _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "Play",
                                      params: {
                                        id: _vm.id,
                                        piva: _vm.piva,
                                        cod: _vm.cod_client
                                      }
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass: "center padd",
                                      class: {
                                        "back-color-2 white":
                                          _vm.my_registration_in_promo >
                                          _vm.maxRegistration,
                                        "back-white color uppercase ":
                                          _vm.my_registration_in_promo <=
                                            _vm.maxRegistration && !_vm.empty,
                                        "back-color-3 white uppercase":
                                          _vm.my_registration_in_promo <
                                            _vm.maxRegistration && _vm.empty
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.title) +
                                          "\n          "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !_vm.empty
                                    ? _c(
                                        "small",
                                        { staticClass: "color underline" },
                                        [
                                          _vm._v(
                                            "Premi qui per andare direttamente al caricamento dello\n            scontrino"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-12" },
                        [
                          _vm.my_registration_in_promo < _vm.maxRegistration &&
                          !_vm.empty &&
                          _vm.moment(_vm.now) <=
                            _vm.moment(_vm.end_, "YYYY-MM-DD")
                            ? _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "Play",
                                      params: {
                                        id: _vm.id,
                                        piva: _vm.piva,
                                        cod: _vm.cod_client
                                      }
                                    }
                                  }
                                },
                                [
                                  _c("countdown", {
                                    attrs: { time: _vm.countdown },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(props) {
                                            return [
                                              _vm.vw <= 770 && !_vm.empty
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "mt-1 center activeTxt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                Ti rimangono:\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.vw <= 770 && _vm.empty
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "mt-1 center activeTxt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                Mancano:\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row center justify-content-center pb-2 pt-3 text-right"
                                                },
                                                [
                                                  _vm.vw > 770 && !_vm.empty
                                                    ? _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "mt-3 activeTxt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  Ti rimangono:\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.vw > 770 && _vm.empty
                                                    ? _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "mt-3 activeTxt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  Mancano:\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "countdown ml-2 mr-2 text-center relative",
                                                      style:
                                                        "background: " +
                                                        _vm.contests.config
                                                          .COLORE_SCURO
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "Bold timeVal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(props.days)
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      props.days == 1
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    giorno\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [_vm._v("giorni")]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "countdown ml-2 mr-2 text-center relative",
                                                      style:
                                                        "background: " +
                                                        _vm.contests.config
                                                          .COLORE_SCURO
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "Bold timeVal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(props.hours)
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      props.hours == 1
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic darkBlue Regular mt-1 mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    ora\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [_vm._v("ore")]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "countdown ml-2 mr-2 text-center relative",
                                                      style:
                                                        "background: " +
                                                        _vm.contests.config
                                                          .COLORE_SCURO
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "Bold timeVal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.minutes
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      props.minutes == 1
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    minuto\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [_vm._v("minuti")]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "countdown ml-2 mr-2 text-center relative",
                                                      style:
                                                        "background: " +
                                                        _vm.contests.config
                                                          .COLORE_SCURO
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "Bold timeVal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.seconds
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      props.seconds == 1
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    secondo\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "classic Regular mt-1 mb-0"
                                                            },
                                                            [_vm._v("secondi")]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.vw >= 770 && !_vm.empty
                                                    ? _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "mt-1 activeTxt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  per registrare "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "uno scontrino\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.vw >= 770 && _vm.empty
                                                    ? _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "mt-1 text-left activeTxt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  al termine"
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "della promozione\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.vw < 770 && !_vm.empty
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "mt-1 center activeTxt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                per registrare uno scontrino\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.vw < 770 && _vm.empty
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "mt-1 center activeTxt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                al termine della promozione\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3705344063
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "center black Bold mr-lg-5 mb-md-5 mt-lg-0 mt-3"
                            },
                            [
                              _vm._v("\n          Validitá promozione: dal "),
                              _c("b", { staticClass: "underline" }, [
                                _vm._v(_vm._s(_vm.start))
                              ]),
                              _vm._v(" al\n          "),
                              _c("b", { staticClass: "underline" }, [
                                _vm._v(_vm._s(_vm.end_rec)),
                                _c("br")
                              ]),
                              _vm._v(
                                "con possibilità di\n          caricare gli scontrini fino al "
                              ),
                              _c("b", [_vm._v(_vm._s(_vm.end))])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.empty
                        ? _c("div", { staticClass: "col-md-10 center" }, [
                            _vm.finish
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "bordered-1 Black Bold h3 mt-3"
                                  },
                                  [
                                    _vm._v(
                                      "\n          Promozione terminata\n        "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v("\n        Validitá promozione: dal "),
                            _c("b", { staticClass: "underline" }, [
                              _vm._v(_vm._s(_vm.start))
                            ]),
                            _vm._v(" al\n        "),
                            _c("b", { staticClass: "underline" }, [
                              _vm._v(_vm._s(_vm.end_rec)),
                              _c("br")
                            ]),
                            _vm._v(
                              " con possibilità di\n        caricare gli scontrini fino al "
                            ),
                            _c("b", [_vm._v(_vm._s(_vm.end))])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.contests.config
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-4 col-md-4 pt-5 mt-lg-0 mt-md-4 center mb-3 mb-md-0"
                            },
                            [
                              !!_vm.contests.config.REGOLAMENTO
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.contests.config.REGOLAMENTO,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "\n              center\n              uppercase\n              white\n              bordered\n              back-color-1\n              btn btn-primary-4\n              mb-2\n            ",
                                          style:
                                            "background: " +
                                            _vm.contests.config
                                              .COLORE_MEDIO_SCURO +
                                            "!important"
                                        },
                                        [
                                          _vm._v("\n            Regolamento "),
                                          _c("img", { attrs: { src: _vm.doc } })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("br"),
                              !!_vm.contests.config.FAQ
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.contests.config.FAQ,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "\n              center\n              uppercase\n              back-color-1\n              white\n              bordered\n              btn btn-primary-4\n            ",
                                          style:
                                            "background: " +
                                            _vm.contests.config
                                              .COLORE_MEDIO_SCURO +
                                            "!important"
                                        },
                                        [
                                          _vm._v("\n            Faq "),
                                          _c("img", { attrs: { src: _vm.doc } })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.finish
                        ? _c(
                            "div",
                            { staticClass: "col-md-4 col-8 text-left" },
                            [
                              _vm.vw > 1000
                                ? _c("vue-gauge", {
                                    attrs: {
                                      refid: "type-unique-id",
                                      options: {
                                        needleValue:
                                          _vm.my_registration_in_promo,
                                        chartWidth: [_vm.vw * 0.2],
                                        centralLabel: [""],
                                        arcColors: [
                                          "" +
                                            _vm.contests.config
                                              .COLORE_MEDIO_SCURO +
                                            "",
                                          "" +
                                            _vm.contests.config
                                              .COLORE_MEDIO_CHIARO +
                                            "",
                                          "" +
                                            _vm.contests.config.COLORE_SCURO +
                                            ""
                                        ],
                                        arcLabels: [55, 80, 100],
                                        arcDelimiters: [55, 80, 99],
                                        hasNeedle: [true],
                                        arcOverEffect: [true],
                                        needleColor: ["#f29daf"]
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.vw > 600 && _vm.vw < 1000
                                ? _c("vue-gauge", {
                                    attrs: {
                                      refid: "type-unique-id",
                                      options: {
                                        needleValue:
                                          _vm.my_registration_in_promo,
                                        chartWidth: [_vm.vw * 0.3],
                                        centralLabel: [""],
                                        arcColors: [
                                          "" +
                                            _vm.contests.config
                                              .COLORE_MEDIO_SCURO +
                                            "",
                                          "" +
                                            _vm.contests.config
                                              .COLORE_MEDIO_CHIARO +
                                            "",
                                          "" +
                                            _vm.contests.config.COLORE_SCURO +
                                            ""
                                        ],
                                        arcLabels: [55, 80, 100],
                                        arcDelimiters: [55, 80, 99],
                                        hasNeedle: [true],
                                        arcOverEffect: [true],
                                        needleColor: ["#f29daf"]
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.vw < 600
                                ? _c("vue-gauge", {
                                    attrs: {
                                      refid: "type-unique-id",
                                      options: {
                                        needleValue:
                                          _vm.my_registration_in_promo,
                                        chartWidth: [_vm.vw * 0.6],
                                        centralLabel: [""],
                                        arcColors: [
                                          "" +
                                            _vm.contests.config
                                              .COLORE_MEDIO_SCURO +
                                            "",
                                          "" +
                                            _vm.contests.config
                                              .COLORE_MEDIO_CHIARO +
                                            "",
                                          "" +
                                            _vm.contests.config.COLORE_SCURO +
                                            ""
                                        ],
                                        arcLabels: [55, 80, 100],
                                        arcDelimiters: [55, 80, 99],
                                        hasNeedle: [true],
                                        arcOverEffect: [true],
                                        needleColor: ["#f29daf"]
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "punti Bold h5 text-center" },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.my_registration_in_promo) +
                                        " punti ottenuti"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n            su " +
                                        _vm._s(
                                          _vm.my_registration_in_promo_done
                                        ) +
                                        " richiesti"
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.empty && !_vm.finish
                        ? _c(
                            "div",
                            { staticClass: "col-lg-4 col-md-4 mt-5 pt-4" },
                            [_vm._m(0)]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.empty && !_vm.finish
                    ? _c(
                        "div",
                        {
                          staticClass: "row justify-content-center pt-md-5",
                          class: {
                            "back-white": !_vm.empty && _vm.contest && !_vm.info
                          }
                        },
                        [
                          _vm.contests.config.STEP_1
                            ? _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-10 mt-4 pt-1" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "pull-left customHowTo"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.contests.config.STEP_1)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contests.config.STEP_2
                            ? _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-10 mt-4 pt-1" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "pull-left customHowTo"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.contests.config.STEP_2)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contests.config.STEP_3
                            ? _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-10 mt-4 pt-1" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "pull-left customHowTo"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.contests.config.STEP_3)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contests.config.STEP_4
                            ? _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "row" }, [
                                  _vm._m(4),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-10 mt-4 pt-1" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "pull-left customHowTo"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.contests.config.STEP_4)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.empty && _vm.finish
                    ? _c(
                        "div",
                        {
                          staticClass: "row justify-content-center",
                          class: {
                            "back-white": !_vm.empty && _vm.contest && !_vm.info
                          }
                        },
                        [
                          _c("div", { staticClass: "col-10" }, [
                            _c("img", {
                              staticClass: "img-fluid img",
                              attrs: { src: _vm.contests.config.IMMAGINE_HOME }
                            })
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row pt-5 pb-5 back-white",
                      class: {
                        "back-white justify-content-center":
                          !_vm.empty && _vm.contest && !_vm.info
                      }
                    },
                    [
                      !_vm.empty &&
                      _vm.contest &&
                      !_vm.info &&
                      _vm.moment(_vm.now) <= _vm.moment(_vm.end_, "YYYY-MM-DD")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-12 col-md-5 center mt-md-4 mt-5 pt-lg-0 pt-md-4"
                            },
                            [
                              _vm.my_registration_in_promo < _vm.maxRegistration
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-primary",
                                      style:
                                        "background: " +
                                        _vm.contests.config.COLORE_SCURO +
                                        "!important",
                                      attrs: {
                                        to: {
                                          name: "Play",
                                          params: {
                                            id: _vm.id,
                                            piva: _vm.piva,
                                            cod: _vm.cod_client
                                          }
                                        }
                                      }
                                    },
                                    [_vm._v("Registra uno scontrino")]
                                  )
                                : _c(
                                    "p",
                                    {
                                      staticClass:
                                        "bordered-1 back-color white Medium h5",
                                      style:
                                        "background: " +
                                        _vm.contests.config.COLORE_SCURO +
                                        "!important"
                                    },
                                    [
                                      _vm._v(
                                        "\n          Numero massimo di richieste di rimborso raggiunto\n        "
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.empty && _vm.contest && !_vm.info
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "center mt-md-4 mt-5 pt-lg-0 pt-md-4",
                              class: {
                                "col-12":
                                  _vm.moment(_vm.now) >=
                                  _vm.moment(_vm.end, "DD-MM-YYYY"),
                                "col-lg-5 col-md-5":
                                  _vm.moment(_vm.now) <=
                                  _vm.moment(_vm.end_, "YYYY-MM-DD")
                              }
                            },
                            [
                              _vm.moment(_vm.now) <
                              _vm.moment(_vm.start, "YYYY-MM-DD HH:mm:ss")
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "bordered-1 back-color black Bold uppercase",
                                      style:
                                        "background: " +
                                        _vm.contests.config.COLORE_SCURO +
                                        "!important;color: " +
                                        _vm.contests.config.COLORE_CHIARO +
                                        "!important"
                                    },
                                    [
                                      _vm._v(
                                        "\n          Promozione non ancora iniziata\n        "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.moment(_vm.now) >=
                              _vm.moment(_vm.end, "DD-MM-YYYY")
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "bordered-1 back-color black Bold uppercase",
                                      style:
                                        "background: " +
                                        _vm.contests.config.COLORE_SCURO +
                                        "!important;color: " +
                                        _vm.contests.config.COLORE_CHIARO +
                                        "!important"
                                    },
                                    [
                                      _vm._v(
                                        "\n          Promozione terminata\n        "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            : _vm.info && !_vm.contest && !_vm.premi
            ? _c("div", { attrs: { id: "nav-profile " } }, [
                _c(
                  "div",
                  { staticClass: "container mt-5 pb-5 mb-5 back-white" },
                  [
                    _vm.playContest != ""
                      ? _c(
                          "div",
                          {
                            staticClass: "row justify-content-center pl-3 pr-3"
                          },
                          [
                            _c(
                              "badger-accordion",
                              { ref: "activeAccordion" },
                              [
                                _c(
                                  "badger-accordion-item",
                                  {
                                    on: {
                                      close: function($event) {
                                        _vm.selectedPlay = {}
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "template",
                                      {
                                        staticClass: "center black",
                                        slot: "header"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row justify-content-center mb-5 pb-5"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 col-md-10 mt-3 center"
                                              },
                                              [
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass: "uppercase",
                                                    class: {
                                                      "back-white color": !_vm.empty,
                                                      "back-color-3 white":
                                                        _vm.empty
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(_vm.title) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "color underline"
                                                  },
                                                  [
                                                    _c("br"),
                                                    _vm._v(
                                                      "Premi qui per vedere tutte le tue richieste\n                    punti"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("br")
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-6 col-10 mb-md-0 mb-5"
                                              },
                                              [
                                                _vm.vw > 600
                                                  ? _c("vue-gauge", {
                                                      attrs: {
                                                        refid: "type-unique-id",
                                                        options: {
                                                          needleValue:
                                                            _vm.my_registration_in_promo,
                                                          chartWidth: [500],
                                                          centralLabel: [""],
                                                          arcColors: [
                                                            "" +
                                                              _vm.contests
                                                                .config
                                                                .COLORE_MEDIO_SCURO +
                                                              "",
                                                            "" +
                                                              _vm.contests
                                                                .config
                                                                .COLORE_MEDIO_CHIARO +
                                                              "",
                                                            "" +
                                                              _vm.contests
                                                                .config
                                                                .COLORE_SCURO +
                                                              ""
                                                          ],
                                                          arcLabels: [
                                                            55,
                                                            80,
                                                            100
                                                          ],
                                                          arcDelimiters: [
                                                            55,
                                                            80,
                                                            99
                                                          ],
                                                          hasNeedle: [true],
                                                          arcOverEffect: [true],
                                                          needleColor: [
                                                            "#f29daf"
                                                          ]
                                                        }
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.vw < 600
                                                  ? _c("vue-gauge", {
                                                      attrs: {
                                                        refid: "type-unique-id",
                                                        options: {
                                                          needleValue:
                                                            _vm.my_registration_in_promo,
                                                          chartWidth: [300],
                                                          centralLabel: [""],
                                                          arcColors: [
                                                            "" +
                                                              _vm.contests
                                                                .config
                                                                .COLORE_MEDIO_SCURO +
                                                              "",
                                                            "" +
                                                              _vm.contests
                                                                .config
                                                                .COLORE_MEDIO_CHIARO +
                                                              "",
                                                            "" +
                                                              _vm.contests
                                                                .config
                                                                .COLORE_SCURO +
                                                              ""
                                                          ],
                                                          arcLabels: [
                                                            55,
                                                            80,
                                                            100
                                                          ],
                                                          arcDelimiters: [
                                                            55,
                                                            80,
                                                            99
                                                          ],
                                                          hasNeedle: [true],
                                                          arcOverEffect: [true],
                                                          needleColor: [
                                                            "#f29daf"
                                                          ]
                                                        }
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "punti Bold h5 text-center"
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.my_registration_in_promo
                                                        ) + " punti ottenuti"
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                      su " +
                                                          _vm._s(
                                                            _vm.my_registration_in_promo_done
                                                          ) +
                                                          " richiesti"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.playContest, function(
                                      some,
                                      cod
                                    ) {
                                      return _c(
                                        "template",
                                        {
                                          staticClass: "mb-4",
                                          slot: "content"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              key: cod,
                                              staticClass:
                                                "row justify-content-center",
                                              attrs: { id: "centerEl" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "scroll-to",
                                                          rawName:
                                                            "v-scroll-to",
                                                          value: {
                                                            el: ".itemReview",
                                                            offset: -155,
                                                            duration: 900,
                                                            force: false
                                                          },
                                                          expression:
                                                            "{\n                      el: '.itemReview',\n                      offset: -155,\n                      duration: 900,\n                      force: false,\n                    }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "\n                      widthFull\n                      center\n                      text-left\n                      mini\n                      pointer\n                      cusCol\n                      mb-2\n                      mt-2\n                      font\n                      Bold\n                    ",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.selectedPlay = {}
                                                          _vm.selectedPlay[
                                                            cod
                                                          ] = some
                                                          _vm.secondClick(cod)
                                                          _vm.print(
                                                            _vm.selectedPlay
                                                          )
                                                          _vm.showShipForm = false
                                                        }
                                                      }
                                                    },
                                                    [
                                                      some.status == 0 ||
                                                      some.status == 2 ||
                                                      some.status == 1
                                                        ? _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "color"
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  staticClass:
                                                                    "helper mr-1",
                                                                  attrs: {
                                                                    icon:
                                                                      "info-circle",
                                                                    size: "2x"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                      Caricamento\n                      "
                                                              ),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "black"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[ N° " +
                                                                      _vm._s(
                                                                        some.codicePratica
                                                                      ) +
                                                                      " ] "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "del\n                      "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .moment(
                                                                            some.playDate
                                                                          )
                                                                          .format(
                                                                            "DD-MM-YYYY"
                                                                          )
                                                                      )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "( In corso di validazione )"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "underline mt-3 mt-lg-0"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mostra dettagli"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      some.status == 20 ||
                                                      some.status == 102
                                                        ? _c(
                                                            "h5",
                                                            {
                                                              staticClass: "red"
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  staticClass:
                                                                    "helper mr-1",
                                                                  attrs: {
                                                                    icon:
                                                                      "times-circle",
                                                                    size: "2x"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                      Caricamento\n                      "
                                                              ),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "black"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[ N° " +
                                                                      _vm._s(
                                                                        some.codicePratica
                                                                      ) +
                                                                      " ] "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "del\n                      "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .moment(
                                                                            some.playDate
                                                                          )
                                                                          .format(
                                                                            "DD-MM-YYYY"
                                                                          )
                                                                      )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              some.status == 20
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Non valido )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              some.status == 102
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Non rimborsato )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "underline mt-3 mt-lg-0"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mostra dettagli"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      some.status == 10 ||
                                                      some.status == 100 ||
                                                      some.status == 101 ||
                                                      some.status == 110
                                                        ? _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "green"
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  staticClass:
                                                                    "helper mr-1",
                                                                  attrs: {
                                                                    icon:
                                                                      "check-circle",
                                                                    size: "2x"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                      Caricamento\n                      "
                                                              ),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "black"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "[ N° " +
                                                                      _vm._s(
                                                                        some.codicePratica
                                                                      ) +
                                                                      " ] "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "del\n                      "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .moment(
                                                                            some.playDate
                                                                          )
                                                                          .format(
                                                                            "DD-MM-YYYY"
                                                                          )
                                                                      )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              some.status == 10
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Validato )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              some.status == 100
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( In fase di assegnazione punti )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              some.status == 101
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Punti assegnati )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              some.status == 110
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger font"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "( Rimborsato )"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "underline mt-3 mt-lg-0"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mostra dettagli"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "container-fluid"
                                                },
                                                [
                                                  !!_vm.selectedPlay[cod]
                                                    ? _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: !!_vm
                                                                .selectedPlay[
                                                                cod
                                                              ],
                                                              expression:
                                                                "!!selectedPlay[cod]"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "row mb-5 itemReview justify-content-center"
                                                        },
                                                        [
                                                          _vm.selectedPlay[cod]
                                                            .status == 20
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-12 center mt-2 mb-2"
                                                                },
                                                                [
                                                                  _c(
                                                                    "h5",
                                                                    {
                                                                      staticClass:
                                                                        "Bold red"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                        Motivazione di invalidazione: "
                                                                      ),
                                                                      _c("br"),
                                                                      _vm._v(
                                                                        "\n                        " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .selectedPlay[
                                                                              cod
                                                                            ]
                                                                              .motivation
                                                                          ) +
                                                                          "\n                      "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-md-6 mt-5 colSxRiepilogo",
                                                              style:
                                                                "background: " +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_CHIARO +
                                                                "!important"
                                                            },
                                                            [
                                                              _c("h5", [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black customHowTo",
                                                                    style:
                                                                      "padding:10px;border-radius:10px;background: " +
                                                                      _vm
                                                                        .contests
                                                                        .config
                                                                        .COLORE_SCURO +
                                                                      "!important"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          Riepilogo dati inseriti:\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Totale scontrino:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .selectedPlay[
                                                                            cod
                                                                          ]
                                                                            .recVal
                                                                        ) +
                                                                        "€\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Data emissione scontrino:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .moment(
                                                                              _vm
                                                                                .selectedPlay[
                                                                                cod
                                                                              ]
                                                                                .recDate
                                                                            )
                                                                            .format(
                                                                              "DD-MM-YYYY"
                                                                            )
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Ora emissione scontrino:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .selectedPlay[
                                                                            cod
                                                                          ]
                                                                            .recTime
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Data inserimento dati:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .moment(
                                                                              _vm
                                                                                .selectedPlay[
                                                                                cod
                                                                              ]
                                                                                .playDate
                                                                            )
                                                                            .format(
                                                                              "DD-MM-YYYY"
                                                                            )
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "black Medium mb-2"
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Prodotti registrati:"
                                                                      )
                                                                    ])
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "table",
                                                                  {
                                                                    staticClass:
                                                                      "mt-3"
                                                                  },
                                                                  [
                                                                    _c("thead"),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "tbody",
                                                                      [
                                                                        _c(
                                                                          "tr",
                                                                          [
                                                                            _c(
                                                                              "td",
                                                                              {
                                                                                staticClass:
                                                                                  "bordered Bold center",
                                                                                style:
                                                                                  "background: " +
                                                                                  _vm
                                                                                    .contests
                                                                                    .config
                                                                                    .COLORE_SCURO +
                                                                                  "!important"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                Prodotto\n                              "
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              {
                                                                                staticClass:
                                                                                  "bordered Bold center",
                                                                                style:
                                                                                  "background: " +
                                                                                  _vm
                                                                                    .contests
                                                                                    .config
                                                                                    .COLORE_SCURO +
                                                                                  "!important"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                Punteggio\n                              "
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              {
                                                                                staticClass:
                                                                                  "bordered Bold center",
                                                                                style:
                                                                                  "background: " +
                                                                                  _vm
                                                                                    .contests
                                                                                    .config
                                                                                    .COLORE_SCURO +
                                                                                  "!important"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                Quantitá\n                              "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _vm._l(
                                                                          JSON.parse(
                                                                            _vm
                                                                              .selectedPlay[
                                                                              cod
                                                                            ]
                                                                              .products
                                                                          ),
                                                                          function(
                                                                            prod,
                                                                            index
                                                                          ) {
                                                                            return [
                                                                              _c(
                                                                                "tr",
                                                                                {
                                                                                  key: index
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "td",
                                                                                    {
                                                                                      staticClass:
                                                                                        "bordered center Bold small"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                  " +
                                                                                          _vm._s(
                                                                                            prod.product
                                                                                          ) +
                                                                                          "\n                                "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "td",
                                                                                    {
                                                                                      staticClass:
                                                                                        "bordered center Bold small"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                  " +
                                                                                          _vm._s(
                                                                                            prod.points
                                                                                          ) +
                                                                                          "\n                                "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "td",
                                                                                    {
                                                                                      staticClass:
                                                                                        "bordered center Bold small"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                  " +
                                                                                          _vm._s(
                                                                                            prod.quantity
                                                                                          ) +
                                                                                          "\n                                "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          }
                                                                        )
                                                                      ],
                                                                      2
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "\n                        col-md-5\n                        center\n                        ml-md-5\n                        mt-md-5 mt-2 mt-md-0\n                        colDxRiepilogo\n                      ",
                                                              style:
                                                                "background: linear-gradient(87deg,rgba(255,255,255,1) 0%," +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_CHIARO +
                                                                " 15%," +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_MEDIO_CHIARO +
                                                                " 62%," +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_MEDIO_SCURO +
                                                                " 100%," +
                                                                _vm.contests
                                                                  .config
                                                                  .COLORE_SCURO +
                                                                " 100%)"
                                                            },
                                                            [
                                                              _vm.selectedPlay[
                                                                cod
                                                              ].receipt &&
                                                              !_vm.selectedPlay[
                                                                cod
                                                              ].receipt
                                                                .toUpperCase()
                                                                .includes(
                                                                  ".PDF"
                                                                )
                                                                ? _c(
                                                                    "viewer",
                                                                    {
                                                                      staticClass:
                                                                        "images clearfix widthFull",
                                                                      on: {
                                                                        inited:
                                                                          _vm.inited
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "img-fluid img-mod mb-5",
                                                                          staticStyle: {
                                                                            "border-radius":
                                                                              "5px !important"
                                                                          },
                                                                          attrs: {
                                                                            src:
                                                                              _vm
                                                                                .selectedPlay[
                                                                                cod
                                                                              ]
                                                                                .receipt
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "div",
                                                                    {
                                                                      ref:
                                                                        "inv",
                                                                      refInFor: true,
                                                                      staticClass:
                                                                        "mt-5 mb-5"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "small",
                                                                        {
                                                                          staticClass:
                                                                            "uppercase white btn-primary mb-5 mt-5 small",
                                                                          staticStyle: {
                                                                            padding:
                                                                              "7px",
                                                                            "font-size":
                                                                              "14px !important",
                                                                            "border-radius":
                                                                              "5px !important"
                                                                          },
                                                                          style:
                                                                            "background: " +
                                                                            _vm
                                                                              .contests
                                                                              .config
                                                                              .COLORE_SCURO +
                                                                            "!important",
                                                                          attrs: {
                                                                            href:
                                                                              _vm
                                                                                .selectedPlay[
                                                                                cod
                                                                              ]
                                                                                .receipt,
                                                                            target:
                                                                              "_blank"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Clicca qui per vedere il pdf"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "h4",
                                                                {
                                                                  staticClass:
                                                                    "Bold pt-3 pb-3 black",
                                                                  style:
                                                                    "border-radius:10px;background: " +
                                                                    _vm.contests
                                                                      .config
                                                                      .COLORE_CHIARO +
                                                                    "!important"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        ID PRATICA : " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .selectedPlay[
                                                                          cod
                                                                        ]
                                                                          .codicePratica
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              some.status ==
                                                                0 && !_vm.empty
                                                                ? _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "\n                          btn btn-primary\n                          uppercase\n                          btn-small\n                          mt-3 mt-lg-0\n                        ",
                                                                      style:
                                                                        "background: " +
                                                                        _vm
                                                                          .contests
                                                                          .config
                                                                          .COLORE_MEDIO_SCURO +
                                                                        "!important",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.disablePlay(
                                                                            _vm
                                                                              .selectedPlay[
                                                                              cod
                                                                            ]
                                                                              .codicePratica
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                        Cancella registrazione\n                      "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticClass:
                                                              "col-md-12 mt-5"
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.playContest != ""
                      ? _c("div", {
                          staticClass:
                            "row mb-5 itemReview justify-content-center"
                        })
                      : _vm.playContest == "" && _vm.loadingState
                      ? _c("div", { staticClass: "row" }, [_vm._m(5)])
                      : _c("div", { staticClass: "row mt-5 pt-5 back-white" }, [
                          !_vm.empty &&
                          !_vm.contest &&
                          _vm.info &&
                          _vm.moment(_vm.now) <=
                            _vm.moment(_vm.end_, "YYYY-MM-DD")
                            ? _c("div", { staticClass: "col center mt-5" }, [
                                _c(
                                  "h1",
                                  {
                                    staticClass:
                                      "tizaFont bbaRed Bold uppercase center widthFull mt-5 mb-5"
                                  },
                                  [
                                    _vm._v(
                                      "\n            Non hai ancora inserito richieste punti\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("h3", { staticClass: "mt-5" }),
                                _vm._v(" "),
                                !_vm.contest
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-primary-1 mt-5 uppercase",
                                        style:
                                          "background: " +
                                          _vm.contests.config.COLORE_SCURO +
                                          "!important",
                                        on: {
                                          click: function($event) {
                                            return _vm.changeView(1)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Registra subito il primo scontrino"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : !_vm.empty && !_vm.contest && _vm.info
                            ? _c("div", { staticClass: "col center mt-5" }, [
                                _c(
                                  "h1",
                                  {
                                    staticClass:
                                      "tizaFont bbaRed center Bold uppercase widthFull mt-5 mb-5"
                                  },
                                  [
                                    _vm._v(
                                      "\n            Non hai caricato richieste punti\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("h3", { staticClass: "mt-5" }),
                                _vm._v(" "),
                                _vm.moment(_vm.now) <
                                _vm.moment(_vm.start, "YYYY-MM-DD HH:mm:ss")
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "btn btn-primary-1 pt-1 mt-5 uppercase",
                                        style:
                                          "background: " +
                                          _vm.contests.config.COLORE_SCURO +
                                          "!important;color: " +
                                          _vm.contests.config.COLORE_CHIARO +
                                          "!important"
                                      },
                                      [
                                        _vm._v(
                                          "\n            Promozione non ancora iniziata\n          "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.moment(_vm.now) >=
                                _vm.moment(_vm.end, "DD-MM-YYYY")
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "black mt-5 h2 pt-1 pb-1 uppercase",
                                        style:
                                          "border-radius:10px;background: " +
                                          _vm.contests.config.COLORE_SCURO +
                                          "!important;color: " +
                                          _vm.contests.config.COLORE_CHIARO +
                                          "!important"
                                      },
                                      [
                                        _vm._v(
                                          "\n            Promozione terminata\n          "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.info && !_vm.contest && _vm.premi
            ? _c("div", { staticClass: "container" }, [
                _c(
                  "div",
                  { staticClass: "row justify-content-center back-white" },
                  [
                    _c("div", { staticClass: "col-10 pt-5 mt-2 mb-5 center" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 center mb-5" }, [
                      _c("h5", [
                        _vm._v(
                          "\n          “ Al termine dell’attività, in base alla soglia punti raggiunta,\n          avrai diritto a un credito da spendere sul sito Mygiftcardsquare.\n          Potrai scegliere tra tantissimi brand disponibili!”\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn-primary-4 btn white",
                          style:
                            "background: " +
                            _vm.contests.config.COLORE_MEDIO_SCURO +
                            "!important;color: " +
                            _vm.contests.config.COLORE_CHIARO +
                            "!important",
                          attrs: {
                            href: "https://www.mygiftcardsquare.it/home",
                            target: "_blank"
                          }
                        },
                        [
                          _c("b", { staticClass: "white Bold" }, [
                            _vm._v("Vai al sito MygiftcardSquare")
                          ])
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row justify-content-center" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _vm.vw > 800
                      ? _c("img", {
                          staticClass: "img img-fluid",
                          attrs: {
                            src: require("../../assets/images/premi.png")
                          }
                        })
                      : _c("img", {
                          staticClass: "img img-fluid",
                          attrs: {
                            src: require("../../assets/images/premi-mob.png")
                          }
                        })
                  ])
                ])
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "customHowTo pull-left" }, [
      _c("img", {
        staticClass: "img img-fluid",
        attrs: { src: require("../../assets/images/soglie.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("b", { staticClass: "text-left step" }, [_vm._v("1"), _c("br")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("b", { staticClass: "text-left step" }, [_vm._v("2"), _c("br")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("b", { staticClass: "text-left step" }, [_vm._v("3"), _c("br")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("b", { staticClass: "text-left step" }, [_vm._v("4"), _c("br")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col center" }, [
      _c("h3", [_vm._v("Carico ....")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07e343be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e343be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contest/template_soglia_premiofisico.vue
// module id = null
// module chunks = 